import '../scss/theme.scss';
import 'bootstrap';
import mobileMenu from './utils/hcOffcanvasNav';
import lazyload from './utils/lazyload';


import Swiper from 'swiper';
import {Navigation, Pagination, Scrollbar} from 'swiper/modules';

import 'swiper/css';

// Uncomment if google maps is used in the project
//import { loadGoogleMaps } from './utils/gmap/map';


document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  mobileMenu('#primary-menu', '.hc-menu-toggle');


  document.querySelectorAll('.vertueuse-swiper').forEach((el) => {
    new Swiper(el, {
      slidesPerView: 3.5,
      spaceBetween: 24,
      centeredSlides: true,
      loop: false,
      speed: 600,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },

      scrollbar: {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
        },
        1024: {
          spaceBetween: 40,
        }
        
      },
    });
  });
});

